import React, { Component } from 'react';
import AccountMenu from './account-menu';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import * as actions from 'store/modules/auth/actions';

import logo from 'images/logo.svg';
import lampSvg from 'images/lamp.svg';

import moment from 'moment';
import {DASHBOARD_PATH, DOMAIN_PATH, ANALITICS_PAGE_PATH, BILLING_PATH} from 'routes';

class HeaderLoggedIn extends Component {
  handleLogOut = async e => {
    e.preventDefault();
    const { signOutAction } = this.props;
    await signOutAction();
  };

  state = {
    isMobileMenuOpen: false,
  };

  toggle = () => {
    this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });
  };

  close = () => {
    this.setState({ isMobileMenuOpen: false });
  };

  render() {
    const { isMobileMenuOpen } = this.state;
    const { details } = this.props;
    const expirationDate = moment(details.actual_trial_ends_at);
    const currentDate = moment();
    const expireDays = expirationDate.diff(currentDate, 'days');
    const isExpired = expirationDate.diff(currentDate, 'seconds') < 0;
    return (
      <div className="header">
        <div className="wrapper">
          <div className="header__content" style={{ position: 'relative' }}>
            <Link to="/" className="logo">
              <img src={logo} alt="" />
            </Link>
            {!isExpired && details.actual_trial_ends_at && (
              <div
                className="top-free-trial"
                style={{ position: 'absolute', left: '150px' }}>
                <div className="top-free-trial__lamp">
                  <img src={lampSvg} />
                </div>
                <div className="top-free-trial__info">
                  <p className="std-text bold heading">Free trial</p>
                  <span className="std-text expires">
                    {expireDays === 0
                      ? 'Your access expires today'
                      : `Your access will expire in ${Math.abs(
                          expireDays,
                        )} days`}
                  </span>
                </div>
                <NavLink to={{pathname: BILLING_PATH, from: {source: 'from_upgrade_now'}}} className="btn btn-blue big upgrade">
                  Upgrade now
                </NavLink>
              </div>
            )}
            <button
              className={isMobileMenuOpen ? 'menu-btn opened' : 'menu-btn'}
              onClick={this.toggle}>
              <div className="center-line" />
            </button>
            <div
              className={
                isMobileMenuOpen
                  ? 'topline flex-end opened'
                  : 'topline flex-end'
              }>
              <div className="top-controls">
                <div className="drop-menu top-controls__itm">
                  <AccountMenu navigateTo={this.handleLogOut} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
    token: state.auth.token,
  };
}
export default connect(
  mapStateProps,
  actions,
)(HeaderLoggedIn);



// WEBPACK FOOTER //
// ./src/scenes/Header/HeaderLoggedIn.js